import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type {
  GetPatientSummaryParams,
  PatientSummaryResponse,
} from 'api/executive/executive.types'

export function usePatientSummary() {
  return useExecutiveQuery<GetPatientSummaryParams, PatientSummaryResponse>(
    'performance.patient-summary',
    PerformanceApi.getPatientSummary,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
      }
    }
  )
}
